import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';

import { AuthGuard } from "./guard/auth.guard";


const routes: Routes = [
  { 
    path: '', 
    redirectTo: '/login', 
    pathMatch: 'full' 
  },
  { 
    path: 'login', 
    component: LoginComponent,
    data: { showHeader: false, showSidebar: false }
  },
  { 
    path: 'home',
    loadChildren: () => import('src/app/console/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  { 
    path: 'tasks',
    loadChildren: () => import('src/app/console/tasks/tasks.module').then(m => m.TasksModule), 
    canActivate: [AuthGuard]
  },
  { 
    path: 'reports',
    loadChildren: () => import('src/app/console/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuard]
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
